var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectContactsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1244_14573)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 166.559C159.757 166.559 192 157.132 192 90.6006C192 22.0553 152.926 0.0916061 96 0.0916061C39.074 0.0916061 0 22.0553 0 90.6006C0 157.132 32.2428 166.559 96 166.559Z",
    fill: "#0096FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1244_14573",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 192,
    height: 179
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192 90.6922C192 90.6006 192 90.6006 192 90.5091C192 90.5091 192 90.5091 192 90.4176C192 90.3261 192 90.3261 192 90.2346C191.909 21.8723 152.835 0 96 0C39.165 0 0.0910817 21.8723 0 90.2346C0 90.3261 0 90.3261 0 90.4176C0 90.4176 0 90.4175 0 90.5091C0 90.6006 0 90.6006 0 90.6922C0 91.6073 0 92.5225 0 93.4376C0 93.6207 0 93.7122 0 93.8952C0.455408 124.095 7.01302 162.715 27.5064 171.5C43.3546 178.364 65.4875 179.096 82.2466 178.913C86.6185 178.822 88.6223 173.514 85.4344 170.585C83.9771 169.213 82.4287 167.84 80.8803 166.376C85.7077 166.559 90.7173 166.559 96 166.559C101.283 166.559 106.292 166.467 111.12 166.376C109.571 167.84 108.023 169.213 106.566 170.585C103.378 173.514 105.382 178.913 109.753 178.913C126.512 179.096 148.645 178.364 164.494 171.5C184.987 162.715 191.545 124.004 192 93.8952C192 93.7122 192 93.6207 192 93.4376C192 92.5225 192 91.6073 192 90.6922Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1244_14573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.389 63.512H-13.2979V224.854H205.389V63.512Z",
    fill: "url(#paint0_radial_1244_14573)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6904 106.067C79.3062 106.067 81.4269 103.936 81.4269 101.308C81.4269 98.6797 79.3062 96.5491 76.6904 96.5491C74.0747 96.5491 71.9545 98.6797 71.9545 101.308C71.9545 103.936 74.0747 106.067 76.6904 106.067Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.309 106.067C117.925 106.067 120.045 103.936 120.045 101.308C120.045 98.6797 117.925 96.5491 115.309 96.5491C112.694 96.5491 110.573 98.6797 110.573 101.308C110.573 103.936 112.694 106.067 115.309 106.067Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4344 170.494C61.1156 148.256 26.4137 113.571 0 90.2346C0 120.801 6.28437 162.257 27.5064 171.409C43.3546 178.273 65.4875 179.005 82.2466 178.822C86.6185 178.822 88.7134 173.422 85.4344 170.494Z",
    fill: "#0096FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.565 170.494C130.884 148.256 165.586 113.571 192 90.2346C192 120.801 185.715 162.257 164.493 171.409C148.645 178.273 126.512 179.005 109.753 178.822C105.381 178.822 103.286 173.422 106.565 170.494Z",
    fill: "#0096FA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M151.56 171.226H40.44C36.4324 171.226 33.1534 167.931 33.1534 163.905V109.27C33.1534 105.243 36.4324 101.949 40.44 101.949H151.56C155.567 101.949 158.846 105.243 158.846 109.27V163.905C158.937 167.931 155.658 171.226 151.56 171.226Z",
    fill: "#0066FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M151.56 178.913H40.44C36.4324 178.913 33.1534 175.619 33.1534 171.592V115.31C33.1534 111.283 36.4324 107.989 40.44 107.989H151.56C155.567 107.989 158.846 111.283 158.846 115.31V171.592C158.937 175.619 155.658 178.913 151.56 178.913Z",
    fill: "#0035B5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M152.835 192H39.1653C35.7953 192 33.0626 189.255 33.0626 185.869V184.679C33.0626 181.293 35.7953 178.547 39.1653 178.547H152.835C156.205 178.547 158.938 181.293 158.938 184.679V185.869C158.938 189.255 156.205 192 152.835 192Z",
    fill: "#0066FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9999 135.077C97.4572 135.077 98.9144 135.169 100.372 135.535C103.468 136.359 105.381 138.28 105.928 141.483C106.383 144.046 106.201 146.517 105.29 148.988C104.744 150.452 103.742 151.642 102.649 152.74C101.191 154.112 99.6431 155.485 98.1858 156.858C98.0036 157.041 97.7306 157.224 97.4573 157.499C97.2752 157.682 97.0929 157.773 96.9108 157.682C96.6375 157.59 96.5465 157.407 96.5465 157.133C96.5465 156.4 96.5465 155.668 96.5465 154.936C96.5465 154.387 96.5464 154.387 95.9999 154.387C94.4516 154.387 92.9943 154.204 91.537 153.655C88.8957 152.648 87.2561 150.726 86.4364 147.981C85.7988 145.693 85.7075 143.405 86.254 141.026C86.8916 138.28 88.6222 136.541 91.3547 135.718C92.812 135.26 94.4516 135.077 95.9999 135.077Z",
    fill: "#0096FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1244_14573",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.8587 144.172) scale(141.846 68.0435)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000289352,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1244_14573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectContactsIcon);
export default __webpack_public_path__ + "static/media/SelectContactsIcon.770c3d463d87b1689d0363528153fbf8.svg";
export { ForwardRef as ReactComponent };